import { render, staticRenderFns } from "./SearchStockItems.vue?vue&type=template&id=2a0287e0&scoped=true&"
import script from "./SearchStockItems.vue?vue&type=script&lang=js&"
export * from "./SearchStockItems.vue?vue&type=script&lang=js&"
import style0 from "./SearchStockItems.vue?vue&type=style&index=0&id=2a0287e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0287e0",
  null
  
)

export default component.exports